(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lp-client-results"] && !Shopify.designMode) return;
  try {
    
  function bindClientResults(scope) {
    scope.querySelectorAll('[data-bm-client-results]').forEach(function(section) {
      if(section.dataset.bmBound) return;
      section.dataset.bmBound='1';
      var track=section.querySelector('[data-bm-client-track]');
      var controls=section.querySelector('.bm-client-controls');
      var previous=section.querySelector('[data-bm-client-prev]');
      var next=section.querySelector('[data-bm-client-next]');
      var dialog=section.querySelector('[data-bm-client-dialog]');
      var opener;
      function updateControls() {
        var overflow=track.scrollWidth-track.clientWidth;
        controls.hidden=overflow<5;
        previous.disabled=track.scrollLeft<5;
        next.disabled=track.scrollLeft>=overflow-5;
      }
      function move(direction) {
        var card=track.querySelector('.bm-client-card');
        var gap=parseFloat(getComputedStyle(track).columnGap)||20;
        track.scrollBy({left:direction*(card.getBoundingClientRect().width+gap),behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      }
      previous.addEventListener('click',function(){move(-1);});
      next.addEventListener('click',function(){move(1);});
      track.addEventListener('scroll',updateControls,{passive:true});
      track.addEventListener('keydown',function(event){
        if(event.target!==track) return;
        if(event.key==='ArrowRight'){event.preventDefault();move(1);}
        if(event.key==='ArrowLeft'){event.preventDefault();move(-1);}
      });
      if('ResizeObserver' in window) new ResizeObserver(updateControls).observe(track);
      updateControls();
      section.querySelectorAll('[data-bm-client-open]').forEach(function(button){
        button.addEventListener('click',function(){
          opener=button;
          var image=document.createElement('img');
          image.src=button.dataset.image;
          image.alt=button.dataset.alt;
          image.width=1290;
          image.height=730;
          section.querySelector('[data-bm-client-dialog-title]').textContent=button.dataset.title;
          section.querySelector('[data-bm-client-dialog-content]').replaceChildren(image);
          dialog.showModal();
        });
      });
      section.querySelector('[data-bm-client-close]').addEventListener('click',function(){dialog.close();});
      dialog.addEventListener('click',function(event){
        var rect=dialog.getBoundingClientRect();
        if(event.target===dialog&&(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)) dialog.close();
      });
      dialog.addEventListener('close',function(){if(opener) opener.focus();});
    });
  }
  bindClientResults(document);
  document.addEventListener('shopify:section:load',function(event){bindClientResults(event.target);});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
